(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-with-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Count-up da faixa de stats. ASCII only: nenhum caractere acentuado aqui,
       senao a Shopify TRUNCA o bundle compilado. Texto visivel (unidade, rotulo)
       vem do Liquid, nunca daqui. */
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animateNum(el, target, plus) {
      var duration = 1200;
      var start = null;
      var prefix = plus ? '+' : '';

      function frame(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        var current = Math.round(easeOutCubic(progress) * target);
        el.textContent = prefix + current;
        if (progress < 1) {
          requestAnimationFrame(frame);
        }
      }

      requestAnimationFrame(frame);
    }

    function runStats(row) {
      var nums = row.querySelectorAll('[data-count-animate="true"]');
      nums.forEach(function (el) {
        var target = parseInt(el.getAttribute('data-count-value'), 10);
        if (isNaN(target)) return;
        var plus = el.getAttribute('data-count-plus') === 'true';
        el.textContent = (plus ? '+' : '') + '0';
        animateNum(el, target, plus);
      });
    }

    function init(row) {
      if (!(row instanceof HTMLElement)) return;
      if (row.dataset.statsReady === '1') return;
      row.dataset.statsReady = '1';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hasObserver = 'IntersectionObserver' in window;
      if (reduce || !hasObserver) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runStats(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      observer.observe(row);
    }

    function initAll(scope) {
      var container = scope instanceof Element || scope instanceof Document ? scope : document;
      container.querySelectorAll('[data-about-stats]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-video]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-hero-play]');
    var video = wrap.querySelector('video');
    if (!btn || !video) return;

    btn.addEventListener('click', function () {
      // Facade: os controles nativos so aparecem ao dar play (antes disso o card
      // mostra apenas o poster + o botao e a legenda do nosso overlay).
      wrap.classList.add('is-playing');
      video.controls = true;
      video.play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.bundleReady === '1') return;
      root.dataset.bundleReady = '1';

      var track = root.querySelector('[data-bundle-track]');
      var count = parseInt(root.dataset.count || '0', 10);
      if (!track || count < 2) return;

      var slides = track.children;
      var dots = root.querySelectorAll('[data-bundle-dot]');
      var autoplay = root.dataset.autoplay === 'true';
      var interval = (parseInt(root.dataset.interval || '6', 10) || 6) * 1000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      /* Autoplay stays paused while the pointer or keyboard focus is on the
         carousel. start() respects these flags, so resetting the timer on a
         manual nav (arrow/dot click) does not resume autoplay while hovering;
         it only resumes once both the pointer and focus leave the block. */
      var hovered = false;
      var focused = false;

      function render() {
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        for (var i = 0; i < slides.length; i++) {
          slides[i].setAttribute('aria-hidden', i === index ? 'false' : 'true');
        }
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          if (on) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function go(i) {
        index = (i % count + count) % count;
        render();
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (!autoplay || reduce || hovered || focused) return;
        timer = setInterval(function () {
          go(index + 1);
        }, interval);
      }

      root.querySelectorAll('[data-bundle-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          go(index + 1);
          start();
        });
      });

      root.querySelectorAll('[data-bundle-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          go(index - 1);
          start();
        });
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          go(i);
          start();
        });
      });

      root.addEventListener('mouseenter', function () {
        hovered = true;
        stop();
      });
      root.addEventListener('mouseleave', function () {
        hovered = false;
        start();
      });
      root.addEventListener('focusin', function (event) {
        /* Only pause on keyboard focus (:focus-visible). Focus gained from a
           mouse click on an arrow/dot must not keep autoplay paused: in that
           case the hover state owns it and resumes when the pointer leaves. */
        var target = event.target;
        if (target && target.matches && target.matches(':focus-visible')) {
          focused = true;
          stop();
        }
      });
      root.addEventListener('focusout', function () {
        focused = false;
        start();
      });

      render();
      start();
    }

    function initAll(scope) {
      var container = scope instanceof Element || scope instanceof Document ? scope : document;
      container.querySelectorAll('[data-bundle-carousel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Status aberto/fechado da loja. ASCII only: nenhum caractere acentuado aqui,
       senao a Shopify TRUNCA o bundle compilado. Texto visivel ao usuario
       (aria-label) vem dos data-attributes preenchidos pelo Liquid, nunca daqui. */

    // Hora atual (minutos desde 00:00) e dia da semana (0=domingo) no timezone
    // da loja, nao no fuso do visitante.
    function nowInZone(tz) {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
      var parts = {};
      fmt.formatToParts(new Date()).forEach(function (p) {
        parts[p.type] = p.value;
      });
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var day = days[parts.weekday];
      var hour = parseInt(parts.hour, 10);
      if (hour === 24) hour = 0;
      var minute = parseInt(parts.minute, 10);
      return { day: day, minutes: hour * 60 + minute };
    }

    function toMinutes(hhmm) {
      var bits = String(hhmm).split(':');
      return parseInt(bits[0], 10) * 60 + parseInt(bits[1], 10);
    }

    function isOpen(hours, now) {
      var today = hours[String(now.day)];
      if (!today) return false;
      var open = toMinutes(today[0]);
      var close = toMinutes(today[1]);
      if (close <= open) {
        // Faixa que cruza a meia-noite.
        return now.minutes >= open || now.minutes < close;
      }
      return now.minutes >= open && now.minutes < close;
    }

    function paint(el) {
      var tz = el.getAttribute('data-store-tz') || 'America/Sao_Paulo';
      var raw = el.getAttribute('data-store-hours');
      var hours;
      try {
        hours = JSON.parse(raw);
      } catch (e) {
        return;
      }
      var open = isOpen(hours, nowInZone(tz));
      el.classList.toggle('is-open', open);
      el.classList.toggle('is-closed', !open);
      var label = open ? el.getAttribute('data-label-open') : el.getAttribute('data-label-closed');
      if (label) el.setAttribute('aria-label', label);
    }

    function init(scope) {
      var container = scope instanceof Element || scope instanceof Document ? scope : document;
      // Reduced motion / no-JS fallback: deixa a bolinha neutra, sem afirmar status.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
      var dots = container.querySelectorAll('[data-store-status]');
      if (!dots.length) return;
      dots.forEach(paint);
      if (!window.__storesGridTimer) {
        window.__storesGridTimer = setInterval(function () {
          document.querySelectorAll('[data-store-status]').forEach(paint);
        }, 60000);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
